module.exports = __webpack_public_path__ + "static/media/proces_03.0cf4552a.svg";